//
//
//
//
//
//
//
//
//
//
//

export default {
    options: {
        virtualHost: true
    },
    props: {
        question: String,
        default_fold: Boolean
    },
    mounted () {
        this.fold = this.default_fold
    },
    data () {
        return {
            fold: false
        }
    },
    methods: {
        toggleAnswer () {
            this.fold = !this.fold
        }
    }
}
